// ── 방문빈도 지도 색상 범례 ──────────────────────────────
// 2026-09-17: 본문이 300줄을 넘어 분리 (보이는 모양은 그대로).
import React from 'react';

export function RegionLegend() {
  return (
<div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      {[
        { color: '#3b82f6', label: '1달+ (강력추천)' },
        { color: '#22c55e', label: '4주 이내 (추천)' },
        { color: '#eab308', label: '3주 이내' },
        { color: '#f97316', label: '2주 이내' },
        { color: '#ef4444', label: '1주 이내 (포화)' },
      ].map(({ color, label }) => (
        <span key={label} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--text-muted)' }}>
          <span style={{ width: 11, height: 11, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
          {label}
        </span>
      ))}
      <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>● 크기·색상은 방문 횟수에 따라 바뀔 수 있음</span>
    </div>
  );
}
